import * as Sentry from '@sentry/react'
import React from 'react'
import styled, { css } from 'styled-components'

import { Button } from '@blade/ui-kit'
import { ResetIcon } from '@root/shared/ui-kit'

import { useTranslation } from '../../localization'

interface ErrorBoundaryProps extends React.PropsWithChildren {
  global?: boolean
}

export const ErrorBoundary = ({ global, children }: ErrorBoundaryProps) => {
  const { t } = useTranslation()
  return (
    <Sentry.ErrorBoundary
      fallback={
        <Root $global={global}>
          <Content>
            <Title>{t('common.something-went-wrong')}</Title>
            <Button
              onClick={() => {
                window.location.reload()
              }}
              iconLeft={<ResetIcon />}
            >
              {t('common.reload')}
            </Button>
          </Content>
        </Root>
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}

const Root = styled.div<{ $global?: boolean }>`
  ${({ $global }) =>
    $global
      ? css`
          position: fixed;
          inset: 0;
        `
      : css`
          width: 100%;
          height: 100%;
        `}
  display: flex;
  align-items: center;
  justify-content: center;
`

const Title = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.8px;
  margin-bottom: 16px;
  color: var(--text-12);
`

const Content = styled.div`
  display: grid;
  justify-items: center;
`
